(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("ws"));
	else if(typeof define === 'function' && define.amd)
		define("PeerSoxServer", ["ws"], factory);
	else if(typeof exports === 'object')
		exports["PeerSoxServer"] = factory(require("ws"));
	else
		root["PeerSoxServer"] = factory(root["ws"]);
})(global, function(__WEBPACK_EXTERNAL_MODULE__4__) {
return 